import apiClient from './apiClient';

export const wiederkehrendeRechnungApi = {
  getAll: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await apiClient.get(`/wiederkehrende-rechnungen${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/wiederkehrende-rechnungen/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/wiederkehrende-rechnungen', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/wiederkehrende-rechnungen/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/wiederkehrende-rechnungen/${id}`);
    return response.data;
  },

  trigger: async (id) => {
    const response = await apiClient.post(`/wiederkehrende-rechnungen/${id}/trigger`);
    return response.data;
  }
};

export default wiederkehrendeRechnungApi;
